import { React, useEffect }  from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiGrid, FiBox, FiUsers, FiSettings, FiPlus, FiTrash, FiHome, FiLogOut } from 'react-icons/fi';
import './AdmVertNav.css';

const AdmVertNav = ({ mobileNavOpen, closeMobileNav }) => {
  const navigate = useNavigate();
  const location = useLocation();


  // Navigation items with path matching
  const navItems = [
    { icon: <FiHome />, text: 'Home', path: '/admin/0083/home', exact: true },
    { icon: <FiBox />, text: 'Products', path: '/admin/added-products' },
    { icon: <FiPlus />, text: 'Add Products', path: '/admin/uploadproducts' },
    { icon: <FiUsers />, text: 'Customers', path: '/admin/customers' },
    { icon: <FiSettings />, text: 'Settings', path: '/0083/adminsettings' },
    { icon: <FiTrash />, text: 'Deleted Orders', path: '/admin/deleted-orders' },
    { icon: <FiUsers />, text: 'Admins', path: '/0083/siteadmins' },
   
  ];

  // Check if current path matches nav item
  const isActive = (path, exact = false) => {
    return exact 
      ? location.pathname === path
      : location.pathname.startsWith(path);
  };
const handleLogout = () => {
    localStorage.removeItem('adminName');
    localStorage.removeItem('adminToken');
    navigate('/admin/0083/login');
  };

  return (
    <div className={`adm-vert-nav ${mobileNavOpen ? 'open' : ''}`}>
      <div className="adm-vert-nav-header">
        <h2> Shree Admin Panel</h2>
      </div>
     <nav className="adm-vert-nav-menu">
  <ul>
    {navItems.map((item, index) => (
      <li key={index} className={isActive(item.path, item.exact) ? 'active' : ''}>
        <Link 
          to={item.path} 
          onClick={closeMobileNav}
          className={isActive(item.path, item.exact) ? 'active-link' : ''}
        >
          <span className="nav-icon">{item.icon}</span>
          <span className="nav-text">{item.text}</span>
        </Link>
      </li>
    ))}
    <li>
      <button onClick={handleLogout} className="dropdown-item logout-btn">
        <span className="nav-icon"><FiLogOut /></span>
        <span className="nav-text">Logout</span>
      </button>
    </li>
  </ul>
</nav>

    </div>
  );
};

export default AdmVertNav;
